<script>
import { defineComponent, toRefs, emit } from 'vue';

export default defineComponent({
  name: 'InputChoice',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    step: {
      type: String,
      default: ''
    }
  },
  emits: ['map-answer-values', 'update:modelValue'],
  setup(props, { emit }) {
    const { value, options, step } = toRefs(props);
    const isActive = (optionValue) => value.value === optionValue;

    const handleClick = (selectedValue, index) => {
      const data = {
        step: step.value,
        value: selectedValue,
        intValue: index
      };
      emit('map-answer-values', data);
      emit('update:modelValue', selectedValue);
    };

    return {
      isActive,
      handleClick
    };
  }
});
</script>

<template>
  <div class="buttons-wrapper">
    <button
      v-for="(option, index) in options"
      :key="index"
      :class="{ active: isActive(option.value) }"
      class="button button--field"
      @click.prevent="handleClick(option.value, index)"
    >
      <i :class="[option.className, 'icon icon--button']" />{{ option.name }}
    </button>
  </div>
</template>
